/** Stripe's own capability vocabulary. Null is a fifth answer the enum does not
 *  carry: the capability is absent from the account entirely, which onboarding
 *  cannot create (lastgo-api ADR 0004, addendum of 2026-08-17). */
export type CapabilityStatus = "active" | "pending" | "restricted" | "unsupported" | null;

export interface CapabilityStatusDetail {
  code: string | null;
  resolution: string | null;
}

export interface Capability {
  status: CapabilityStatus;
  statusDetails: CapabilityStatusDetail[];
}

export interface RequirementError {
  code: string | null;
  description: string | null;
}

export interface RestrictedCapability {
  capability: string;
  configuration: string | null;
}

/** One thing Stripe is still waiting for. `description` is a dotted machine path
 *  (`identity.business_details.id_numbers.cz_ico`) and never a label to show;
 *  `errors[].description` is the human half, in English. */
export interface AccountRequirement {
  description: string;
  awaitingActionFrom: string | null;
  deadlineStatus: string | null;
  restrictsCapabilities: RestrictedCapability[];
  errors: RequirementError[];
}

export const tradingCapabilities = ["cardPayments", "transfers", "payouts"] as const;

export type CapabilityName = (typeof tradingCapabilities)[number];

/** `syncError` says the live Stripe read failed and every other field below is
 *  the stored mirror rather than Stripe's current answer. */
export interface PaymentAccount {
  businessId: number;
  accountId: string | null;
  canTrade: boolean;
  syncedAt: Date | null;
  syncError: "STRIPE_UNREACHABLE" | null;
  capabilities: Record<CapabilityName, Capability>;
  requirements: AccountRequirement[];
}
